// extracted by mini-css-extract-plugin
module.exports = {"container":"StaticPage_container__3jo1Q","titleBanner":"StaticPage_titleBanner__25iGF","title":"StaticPage_title__2azju"};